import { z } from "zod";

/** Fits fixed PDF signature slots (border pro forma/TSCA). @see docs/OPT_IN_ORDER_DOCUMENTS.md */
export const TYPED_SIGNATURE_MAX_LENGTH = 80;

/** Org setting: show a typed signature field on the create-document modal. Default off. @see docs/OPT_IN_ORDER_DOCUMENTS.md */
export const AllowTypedSignatureSettingsSchema = z.object({
  allowTypedSignature: z.boolean().default(false),
});

export type AllowTypedSignatureSettings = z.infer<typeof AllowTypedSignatureSettingsSchema>;

/** Create-modal typed name printed in a signature-style font on the PDF. @see docs/OPT_IN_ORDER_DOCUMENTS.md */
export const TypedSignatureInputSchema = z.string().trim().max(TYPED_SIGNATURE_MAX_LENGTH).optional().default("");
